import { defineMessages } from 'react-intl';

export const LEGEND_MESSAGES = defineMessages({
  legendHideSeries: {
    id: 'XPLMI3aOe8TwFwJc',
    defaultMessage: 'Hide',
    description:
      'Text in a tooltip shown when hovering a legend series to hide it',
  },
  legendShowSeries: {
    id: '1e3uPo8SoI4NA2dZ',
    defaultMessage: 'Show',
    description:
      'Text in a tooltip shown when hovering a legend series to show it',
  },
});
